// extracted by mini-css-extract-plugin
export default {"container":"KnitterProfile_container__gqHOH","profilePicture":"KnitterProfile_profilePicture__fYUF1","text":"KnitterProfile_text__K36RD"};